import { motion } from 'framer-motion';
import { VentCard } from './VentCard';

const VentList = ({ vents, sessionId, onUpdate }) => {
  const topLevelVents = vents.filter(v => !v.parent_id);

  return (
    <div className="space-y-4">
      {topLevelVents.map((vent, index) => (
        <motion.div
          key={vent.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
        >
          <VentCard vent={vent} sessionId={sessionId} onUpdate={onUpdate} />
        </motion.div>
      ))}
    </div>
  );
};

export default VentList;
